<template>
  <div v-loading="loading">
    <div class="detail_echart_top">
      <div
        class="detail_top_item"
        v-for="(item, index) in gridList"
        :key="index"
      >
        <div class="detail_top_item_title">{{ item.value }}</div>
        <div class="detail_top_item_value">{{ item.label }}</div>
      </div>
    </div>
    <div class="content_wrap">
      <div class="wrap_search_box" v-show="isShowSearch">
        <el-collapse v-model="openMenu" ref="collapseItem">
          <el-collapse-item title="" name="0">
            <template slot="title">
              <span>Name</span>
              <span class="clear_all" @click.stop="clearParams">
                <i class="iconfont icon-qingchu" />Clear All
              </span>
            </template>

            <el-select
              clearable
              v-model="searchParams.name"
              filterable
              popper-class="new-search-select"
              :popper-append-to-body="true"
              placeholder="Enter Name"
              @change="(val) => onChangeParams(val, 'name')"
            >
              <el-option
                v-for="(item, index) in selectOption"
                :key="index"
                :label="item.name"
                :value="item.value"
              >
                <OverflowTooltip :tip="item.value" />
              </el-option>
            </el-select>
          </el-collapse-item>
          <el-collapse-item title="Department" name="1">
            <el-select
              clearable
              v-model="searchParams.department"
              filterable
              popper-class="new-search-select"
              :popper-append-to-body="true"
              placeholder="Enter Department"
              @change="(val) => onChangeParams(val, 'department')"
            >
              <el-option
                v-for="(item, index) in selectOption"
                :key="index"
                :label="item.name"
                :value="item.value"
              >
                <OverflowTooltip :tip="`${item.value}`" />
              </el-option>
            </el-select>
          </el-collapse-item>
          <el-collapse-item title="Position" name="2">
            <el-select
              clearable
              v-model="searchParams.position"
              filterable
              popper-class="new-search-select"
              :popper-append-to-body="true"
              placeholder="Enter Position"
              @change="(val) => onChangeParams(val, 'position')"
            >
              <el-option
                v-for="(item, index) in selectOption"
                :key="index"
                :label="item.name"
                :value="item.value"
              >
                <OverflowTooltip :tip="`${item.value}`" />
              </el-option>
            </el-select>
          </el-collapse-item>
          <el-collapse-item title="Country" name="3">
            <el-select
              clearable
              v-model="searchParams.country"
              filterable
              popper-class="new-search-select"
              :popper-append-to-body="true"
              placeholder="Enter Country"
              @change="(val) => onChangeParams(val, 'country')"
            >
              <el-option
                v-for="(item, index) in selectOption"
                :key="index"
                :label="item.name"
                :value="item.value"
              >
                <OverflowTooltip :tip="`${item.value}`" />
              </el-option>
            </el-select>
          </el-collapse-item>

          <el-collapse-item title="Email Yes or Not" name="4">
            <el-radio-group
              v-model="searchParams.email"
              @change="(val) => onChangeParams(val, 'email')"
            >
              <el-radio label="1">Yes</el-radio>
              <el-radio label="2">No</el-radio>
            </el-radio-group>
          </el-collapse-item>
          <el-collapse-item title="Phone Yes or Not" name="5">
            <el-radio-group
              v-model="searchParams.phone"
              @change="(val) => onChangeParams(val, 'phone')"
            >
              <el-radio label="1">Yes</el-radio>
              <el-radio label="2">No</el-radio>
            </el-radio-group>
          </el-collapse-item>
          <el-collapse-item title="Social Media Account" name="6">
            <el-select
              clearable
              v-model="searchParams.social"
              filterable
              popper-class="new-search-select"
              :popper-append-to-body="true"
              placeholder="Enter Social Media Account"
              @change="(val) => onChangeParams(val, 'social')"
            >
              <el-option
                v-for="(item, index) in selectOption"
                :key="index"
                :label="item.name"
                :value="item.value"
              >
                <OverflowTooltip :tip="`${item.value}`" />
              </el-option>
            </el-select>
          </el-collapse-item>
          <el-collapse-item title="Certified or Unverified" name="7">
            <el-radio-group
              v-model="searchParams.certified"
              @change="(val) => onChangeParams(val, 'certified')"
            >
              <el-radio label="1">Certified</el-radio>
              <el-radio label="2">Unverified</el-radio>
            </el-radio-group>
          </el-collapse-item>
          <el-collapse-item title="Add Yes or Not" name="8">
            <el-radio-group
              v-model="searchParams.add"
              @change="(val) => onChangeParams(val, 'add')"
            >
              <el-radio label="1">Yes</el-radio>
              <el-radio label="2">No</el-radio>
            </el-radio-group>
          </el-collapse-item>
        </el-collapse>
      </div>
      <div class="wrap_con_box">
        <div class="table_header">
          <div class="table_header_title">Contact Information</div>
          <div class="table_header_menus">
            <el-button :disabled="selectList == 0"
              >Batch Email Sending</el-button
            >
            <el-button :disabled="selectList == 0">Batch Batch</el-button>
            <el-button :disabled="selectList == 0">Add Customer</el-button>
            <el-button>Ai Email Assistant</el-button>
          </div>
        </div>
        <div class="detail_echart_con_box">
          <el-table
            class="risk_table"
            :data="tableData"
            height="100%"
            ref="tableRef"
            @selection-change="onSelectionChange"
            row-key="aaaId"
          >
            <el-table-column
              v-if="isShowSelect"
              :resizable="false"
              type="selection"
              reserve-selection
              align="center"
              class-name="table_check_row"
              width="40"
            />
            <el-table-column prop="name" label="Name" min-width="200">
              <template slot-scope="scope">
                <div class="flex_center_start_box">
                  {{ scope.row.name }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="department"
              label="Department"
              align="center"
              min-width="110"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="position"
              align="center"
              label="Position"
              min-width="120"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="country"
              align="center"
              label="Country"
              min-width="120"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="email"
              align="center"
              label="Email"
              min-width="100"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <i
                  class="iconfont icon-youxiang1"
                  :style="{
                    color: scope.row.email == 1 ? '#8E86DD' : '#CCCCCC',
                  }"
                />
              </template>
            </el-table-column>
            <el-table-column
              prop="phone"
              align="center"
              label="Phone"
              min-width="100"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <i
                  class="iconfont icon-dianhuaheshi"
                  :style="{
                    color: scope.row.phone == 1 ? '#8E86DD' : '#CCCCCC',
                  }"
                />
              </template>
            </el-table-column>

            <el-table-column
              prop="shareholder"
              align="center"
              label="Social Media Account"
              min-width="130"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <div class="cell_img">
                  <img src="../../assets/images/icon_in.png" />
                  <img src="../../assets/images/icon_f.png" />
                  <img src="../../assets/images/icon_x.png" />
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="certified"
              align="center"
              label="Certification"
              min-width="110"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <i
                  class="iconfont icon-dagou"
                  :style="{
                    color: scope.row.certified == 1 ? '#3FB92F' : '#CCCCCC',
                  }"
                />
              </template>
            </el-table-column>
            <el-table-column
              prop="phone"
              align="center"
              label="Whether to add"
              min-width="140"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span v-if="scope.row.phone == 1">Added</span>
                <i v-else class="iconfont icon-gexingmingpian" />
              </template>
            </el-table-column>
            <el-table-column prop="" align="center" label="" min-width="90">
              <template slot-scope="scope">
                <i
                  slot="reference"
                  v-if="scope.row.isSend == 1"
                  class="iconfont icon-youxiang1"
                />
                <i
                  slot="reference"
                  style="color: #3fb92f"
                  v-else
                  class="iconfont icon-a-ziyuan102"
                />
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination_box">
            <Page
              :keyword="$route.query.id3a"
              :fontColor="'#B44818'"
              :total="total"
              :pageSize="searchParams.pageSize"
              :currentPage="searchParams.currentPage"
              @onPageChange="onChangePage"
            ></Page>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mixins1 } from "@/mixins/index";
import Page from "@/views/newLayout/page.vue";
// import RelationshipEchart from "./Com_Tree-echart.vue";
import { getCompanyProfile } from "@/api/companyApi";

export default {
  name: "UboDetail1",
  props: {
    detailInfo: {
      type: Object,
      default: {},
    },
    isShowSearch: {
      type: Boolean,
      default: true,
    },
    isShowSelect: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    Page,
  },
  data() {
    return {
      loading: false,
      openMenu: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
      total: 10,
      searchParams: {
        currentPage: 1,
        pageSize: 5,
        name: [],
        department: [],
        position: [],
        country: [],
        email: "1",
        phone: "1",
        social: [],
        certified: "1",
        add: "1",
      },
      selectList: [],
      selectOption: [
        { name: 1, value: "选项1" },
        { name: 2, value: "选项2" },
        { name: 3, value: "选项3" },
      ],
      gridList: [
        { label: "Number of Personnel", value: "100" },
        { label: "Number of Department", value: "40" },
        { label: "Number of Phone", value: "50" },
        { label: "Number of Email", value: "150" },
        { label: "Mining Rate", value: "60%" },
        { label: "Certification Rate", value: "30%" },
      ],
      tableData: [
        {
          aaaId: "1",
          name: "Albert A. Gore Jr.",
          department: "Management",
          position: "CEO",
          country: "China",
          email: "1",
          phone: "1",
          social: "",
          certified: "1",
          add: "1",
          isSend: "1",
        },
        {
          aaaId: "2",
          name: "Andrea Jung",
          department: "Test  Management Public",
          position: "CEO",
          country: "United States",
          email: "2",
          phone: "2",
          social: "",
          certified: "2",
          add: "2",
          isSend: "2",
        },
      ],
    };
  },
  mixins: [mixins1],

  // components: { RelationshipEchart },
  mounted() {},
  methods: {
    // 检索
    onChangeParams() {
      console.log(3333, this.searchParams);
      this.tableData = [];
      this.searchParams.page = 1;
      this.searchParams.pageSize = 20;
      this.getPageList();
      this.getFilterOptions();
    },
    onChangePage(param) {
      this.searchParams.currentPage = param.page;
      this.searchParams.pageSize = param.pageSize;
      this.getPageList();
    },
    // 表格模式行选择改变时
    onSelectionChange(val) {
      this.selectList = val;
    },
    // 列表
    getPageList() {},
    // 筛选条件
    getFilterOptions() {},
    linkToWebsite(website) {
      if (website && website !== "-") {
        window.open(`http://${website}`, "_blank");
      }
    },
    linkToEmail(email) {
      if (email && email !== "-") {
        window.open(`mailto:${email}`, "_blank");
      }
    },
    linkToSource(source) {
      if (source && source !== "-") {
        if (source.includes("http")) {
          let routeData = source;
          window.open(routeData, "_blank");
        } else {
          let routeData = "http://" + source;
          window.open(routeData, "_blank");
        }
      }
    },
  },
};
</script>
<style scoped>
.link_text {
  color: #8e86dd;
  cursor: pointer;
}
.detail_top_item {
  background: #f0effc;
}
.detail_top_item_title {
  color: #8e86dd;
}
.detail_search {
  width: 100%;
  height: auto;
}
.table_header_menus button {
  background-color: #8e86dd;
  color: #ffffff;
}
.table_header_menus button.is-disabled {
  background: #eeeeee;
  color: #999999;
}
.content_wrap {
  padding: 0;
  padding-bottom: 10px;
}
.wrap_search_box {
  background: #ffffff;
  box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
}

.wrap_search_box .el-collapse,
.wrap_search_box .el-collapse-item {
  border: none;
}
.wrap_search_box >>> .el-collapse-item__header,
.wrap_search_box >>> .el-collapse-item__wrap {
  background: #ffffff;
}
.wrap_con_box {
  padding: 30px 20px 20px 20px;
}
.table_header {
  margin-bottom: 12px;
}
.detail_echart_con_box {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.risk_table >>> .el-table__cell img {
  width: 30px;
  height: 30px;
}
.risk_table >>> .el-table__cell i {
  font-size: 28px;
  color: #8e86dd;
}
.risk_table >>> .cell_img {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
@media (max-width: 1920px) {
  /* .table_header_title {
    margin-bottom: 25px;
  } */
  .content_wrap {
    padding-bottom: 7px;
  }
  .wrap_con_box {
    padding: 22px 14px 14px 14px;
  }
  .table_header {
    margin-bottom: 10px;
  }
  .risk_table >>> .el-table__cell img {
    width: 22px;
    height: 22px;
  }
  .risk_table >>> .el-table__cell i {
    font-size: 22px;
  }
  .risk_table >>> .cell_img {
    gap: 7px;
  }
}
</style>
